export const displayUserAgent = (ua, fallback = "Empty user agent") => {
  const value = (ua ?? "").toString().trim();
  return value ? value : fallback;
};

